(function() {
'use strict';

angular
    .module('TR')
    .service('basketStore', basketStore);

function basketStore($filter,
    $routeParams,
    flightDetail,
    searchUnitService,
    $http,
    $location,
    commonErrors,
    arrayUtil,
    $q,
    $rootScope,
    hotelService,
    transferDetail,
    dateUtil,
    broker,
    hotelSearch,
    marhabaService,
    resourceService,
    carHireDetailsService,
    parkingDetailsService,
    attractionDetailsService,
    adHocService,
    tripService,
    insuranceService,
    cookieService) {
    const productType = {
        Accommodation: 0,
        Flight: 1,
        Transfer: 2,
        Parking: 3,
        Attractions: 4,
        CarHire: 5,
        Marhaba: 6,
        Insurance: 7,
        ProductBundle: 8,
        AdHoc: 9
    };
    const productGroup = {
        Hotel: 1,
        Flight: 2,
        Extra: 3,
        Transfer: 4,
        Parking: 6,
        Attractions: 7
    };
    const productResultMap = {
        h: 'Hotel',
        f: 'Flight',
        t: 'Transfer',
        p: 'Parking',
        a: 'Attractions'
    };
    const bookingExtraOptionsMap = {
        0: 'flights',
        1: 'hotels',
        2: 'transfers',
        3: 'insurance',
        4: 'carHire',
        5: 'parking',
        6: 'attractions',
        7: 'marhaba'
    };
    let basket;
    let attractionsBasket;
    const url = '/api2/basket/';
    const productNames = {
        0: 'ACCOMODATION',
        1: 'FLIGHT',
        2: 'TRANSFER',
        3: 'AIRPORTPARKING',
        4: 'ATTRACTIONS',
        5: 'CARHIRE',
        6: 'MARHABA',
        7: 'TRAVELINSURANCE',
        9: 'ADHOC'
    };
    const productIcons = {
        0: 'icon-hotels',
        1: 'icon-flights',
        2: 'icon-transfers',
        3: 'icon-parking',
        5: 'icon-car-hire',
        6: 'icon-marhaba',
        7: 'icon-insurance',
        9: 'icon-stack'
    };
    let costBreakdownResult;
    let addingFlightResult;
    const titles = {
        1: resourceService.getDeferred('HOTEL'),
        2: resourceService.getDeferred('FLIGHTS'),
        3: resourceService.getDeferred('EXTRAS'),
        4: resourceService.getDeferred('TRANSFER'),
        6: resourceService.getDeferred('PARKING'),
        7: resourceService.getDeferred('ATTRACTIONS'),
        9: resourceService.getDeferred('ADHOC')
    };
    let baseCost;

    const service = {
        getBasket,
        addHotel,
        addVoucher,
        addingFlight,
        addFlight,
        updateBrandedFare,
        addMultiDestHolidayFlight,
        addMultiFlight,
        addTransfer,
        addMarhaba,
        addCar,
        addParking,
        updateProduct,
        putAttractionExtras,
        addAttraction,
        updateAttraction,
        getAttractionsBasket,
        getAttractionsBasketId,
        addInsurance,
        addCancellationProtection,
        removeCancellationProtection,
        balancesDue,
        removeInsurance,
        removeParking,
        removeAttraction,
        removeAttractionsLineItem,
        insurance,
        removeMarhaba,
        addMarhabaOption,
        marhaba,
        marhabaHolidayPath,
        hotel,
        flight,
        transfer,
        flightSpecificInfo,
        flightOptions,
        optionConditions,
        carHireOptions,
        carHire,
        parking,
        attraction,
        adHoc,
        clearBasket,
        destroyBasket,
        setPaymentMethod,
        createBasket,
        removeProductById,
        removeAccomodation,
        removeFlight,
        removeTransfer,
        all,
        removeCar,
        removeOption,
        addOption,
        addOptions,
        removeOptions,
        getNotes,
        addNote,
        addAdHoc,
        addAdjustment,
        getPriceAdjustments,
        getAddedPriceAdjustments,
        getBaseCost,
        baseCostTotal,
        removePriceAdjustment,
        costBreakdown,
        costBreakdownGrouped,
        applyCancelations,
        payments,
        payDirectTotal,
        totalDeposit,
        payDepositAggregates,
        totalCost,
        totalDiscount,
        totalCostFromBasket,
        sumCosts,
        attractionCost,
        carHireCost,
        carHireRequestedItemsCosts,
        flightCost,
        flightBaggageCostings,
        hotelCost,
        hotelDeposit,
        insuranceCost,
        isAtolProtected,
        parkingCost,
        transferCost,
        rules,
        productType,
        productGroup,
        marhabaCost,
        getBasketId,
        getProductCount,
        getDynamicPackage,
        simplifiedBaggageCount,
        updateBaggageOptions,
        updatePriorityBoarding,
        setProductVisibility,
        setAdjustmentVisibility,
        checkBasketBookingAllowed,
        setBasketIdentity,
        getBasketIdentity,
        productNames,
        getTitle,
        getTitleForProduct,
        getBasketCurrency,
        getIconForProduct,
        getCancellationProtectionQuote,
        getTaxAdjustmentValue,
        extrasBreakdown,
        rehydrateBasketForPUP,
        _costByProduct
    };

    function getTitle(type) {
        return titles[type]();
    }

    function getTitleForProduct(p) {
        return (p.group ? titles[p.group]() : productNames[p.ProductType]) || titles[productGroup.Extra]();
    }

    function getIconForProduct(p) {
        return productIcons[p.ProductType];
    }

    function _enrichPayments(b) {
        const data = {
            totalBalances: 0,
            minimumDeposit: 0,
            totalCosts: 0,
            products: []
        };

        const currency = searchUnitService.getCurrency();

        angular.forEach(b.Products, function(prod) {
            data.minimumDeposit += prod.ImmediatePayment.Amount;
            let balance = 0;
            const p = {
                cost: _aggregateCosts(prod.CostBreakdown),
                productType: prod.ProductType,
                productTitle: resourceService.get(productNames[prod.ProductType]),
                initialDeposit: prod.ImmediatePayment.Amount,
                currentDeposit: prod.ImmediatePayment.Amount,
                schedule: arrayUtil.map(prod.FuturePayments, function(pay) {
                    data.totalBalances += pay.Amount;
                    balance += pay.Amount;
                    return {
                        amount: pay.Amount,
                        balance: pay.Amount,
                        due: pay.Due
                    };
                }),
                directPayments: arrayUtil.map(prod.DirectPayments, function(pay) {
                    return {
                        localAmount: pay.LocalAmount,
                        localCurrency: pay.LocalCurrency,
                        amount: pay.Amount,
                        currency
                    };
                }),
                payableLocally: prod.RequestedItems || null
            };
            data.totalCosts += p.cost;
            //for flights we need to include any direct payments in the pay now figure because the payment will always be taken immediately.
            if (prod.ProductType === 1 && prod.DirectPayments.length > 0) {
                p.initialDeposit = p.currentDeposit = prod.ImmediatePayment.Amount + arrayUtil.reduce(arrayUtil.sum, arrayUtil.map(prod.DirectPayments, function(pay) {
                    return pay.Amount;
                }));
            } else if (prod.ProductType === 7) {
                p.productTitle += ` ${resourceService.get('IPTINCLUDED')}`;
            }
            p.balance = balance;
            data.products.push(p);
        });

        const attractions = data.products.filter(item => 4 === item.productType);
        if (attractions.length) {
            const squashedAttractions = attractions.reduce((prev, curr) => ({
                balance: prev.balance + curr.balance,
                currentDeposit: prev.currentDeposit + curr.currentDeposit,
                initialDeposit: prev.initialDeposit + curr.initialDeposit,
                directPayments: prev.directPayments.concat(curr.directPayments),
                payableLocally: prev.directPayments.concat(curr.directPayments),
                schedule: prev.schedule.concat(curr.schedule),
                productTitle: curr.productTitle,
                productType: curr.productType
            }));
            data.products = data.products.filter(item => productType.Attractions !== item.productType);
            data.products.push(squashedAttractions);
        }

        return data;
    }

    function _productsByType(t, basketId, firstOnly) {
        return _getBasket(basketId)
            // `firstOnly` for products that don't support multiples
            .then(b => b == null ? null : _[firstOnly ? 'find' : 'filter'](
                    b.Products,
                    { ProductType: t }
                ));
    }

    function _optionsByType(type, basketId) {
        return _productsByType(type, basketId, true).then(function(p) {
            if (p && p.Options) {
                return arrayUtil.map(p.Options, function(o) {
                    return { OptionId: o.OptionId, Quantity: o.ChosenQuantity || 1 };
                });
            }
            return [];
        });
    }

    function _getBasket(id) {
        if (basket != null) {
            return basket.then(function(r) {
                if (r.BasketId !== id) {
                    basket = _getBasketById(id);
                }
                return basket;
            });
        }
        basket = _getBasketById(id);
        return basket;
    }

    function getBasket(id) {
        return _getBasket(id);
    }

    function _getBasketById(id) {
        costBreakdownResult = null;
        return $http.get(`${url}get?basketId=${id}`)
            .then(function(result) {
                return result.data === 'null' ? null : result.data;
            })
            .then(function(data) {
                if (data && data.Products && data.Products.length && data.Products.length > 0) {
                    let hotelProduct = data.Products.find(p => {
                        return p.ProductType !== undefined && p.ProductType !== null
                             ? p.ProductType === productType.Accommodation
                             : false;
                    });

                    if (hotelProduct) {
                        broker.publish('ProductHotelReceivedFromBasket', { productId: hotelProduct.ProductId, basketId: id });
                    }
                }
                return data;
            });
    }

    function _addProduct(type, searchId, detailsId, basketId, options, packageId, rebookId, replaceBrandedFareType) {
        const params = {
            BasketId: basketId,
            AvailabilitySearchId: searchId,
            ProductType: type,
            ProductId: detailsId,
            Options: options,
            PackageId: packageId,
            RebookId: rebookId,
        };
        if (replaceBrandedFareType) {
            params.IsBrandedFareUpdate = true;
        }
        return $http.post(`${url}addproduct`, params, {
            customErrCallback: TRPCONFIG.Domain.HandleDatesMismatchError ? function(err) {
                if (err.status === 400 && err.data.Message === 'Mismatch between flight and hotel dates') {
                    $location.url('errordatesmismatch');
                } else {
                    commonErrors.fourHundred(err);
                }
            } : undefined
        }).then(function(result) {
            basket = $q.when(result.data);
            costBreakdownResult = null;
            broker.publish('productAddedToBasket');
        });
    }

    function updateProduct(detailsId, basketId) {
        return $http.post(`${url}updateproduct`, {
                BasketId: basketId,
                ProductId: detailsId
            })
            .then(result => {
                basket = $q.when(result.data);
                costBreakdownResult = null;
            });
    }

    function addAdHoc(detailsRequest) {
        return adHocService.getDetails(detailsRequest)
            .then(response => {
                const d = response.data;
                if (d && d.AvailabilityId && d.DetailsId) {
                    return getBasketId().then(basketId => {
                        if (basketId) {
                            return _addProduct(productType.AdHoc
                                , d.AvailabilityId
                                , d.DetailsId
                                , basketId
                                , []);
                        }
                        return $q.when(null);
                    });
                }
            });
    }

    function getPriceAdjustments(basketId) {
        return _getBasket(basketId).then(basket => basket && basket.AvailableAdjustments || []);
    }

    function baseCostTotal() {
        return baseCost;
    }

    function getBaseCost(res) {
        let products = res[5].products;
        let baseCostNum = Number(res[2]);
        let totalCost = Math.ceil(baseCostNum);
        let flightCost;

        for (let i = 0; i < products.length; i++) {
            if (products[i].productTitle === 'FLIGHT') {
                flightCost = Math.ceil(products[i].cost);
            }
        }

        baseCost = totalCost - flightCost;
        return baseCost;
    }

    function getAddedPriceAdjustments(bId) {
        return _getBasket(bId).then(basket =>
            (basket && Array.isArray(basket.Adjustments) ? basket.Adjustments : [])
                .map(item => {
                    return {
                        Id: item.Id,
                        Title: item.Title,
                        CostBreakdown: [{
                            Description: item.Title,
                            Quantity: item.Quantity,
                            NetUnitAmount: item.NetUnitAmount,
                            UnitAmount: item.UnitAmount,
                            ManualCommission: item.ManualCommission || 0,
                            TravelAgentCommissionRate: item.TravelAgentCommissionRate || 0,
                            IsHiddenFromDocumentation: item.IsHidden,
                            IsPriceHidden: item.IsPriceHidden
                        }]
                    };
                })
        );
    }

    function getCancellationProtectionQuote(basketId) {
        let protectionDisabled = {
            IsApplicable: false
        };

        if (!TRPCONFIG.Domain.CancellationProtectionEnabled) {
            return protectionDisabled;
        }

        return $http.get(`api/hotels/cancellationprotection/quote?basketId=${basketId}`)
            .then(res => res.data)
            .catch(() => protectionDisabled);
    }

    function getTaxAdjustmentValue(basketId) {
        return getAddedPriceAdjustments(basketId).then(function(result) {
            let value = 0;
            if (result) {
                const adjustments = result.filter(item => {
                    return item.CostBreakdown && item.CostBreakdown.length;
                });
                if (adjustments && adjustments.length) {
                    _.forEach(adjustments, adjustment => {
                        value += _.get(adjustment, 'CostBreakdown[0].UnitAmount', 0);
                    });
                }
            }
            return value;
        });
    }

    function addAdjustment(adjustmentRequest) {
        return $http.post(`${url}addadjustment`, adjustmentRequest)
            .then(res => _updateBasketPromise(res.data));
    }

    function removePriceAdjustment(basketId, adjustmentId) {
        const req = {
            BasketId: basketId,
            AdjustmentId: adjustmentId,
            ExpectedVersion: 0
        };
        return $http.post(`${url}removeadjustment`, req)
            .then(res => _updateBasketPromise(res.data));
    }

    function _updateBasketPromise(newBasket) {
        basket = $q.when(newBasket);
        costBreakdownResult = null;
        broker.publish('productRemovedFromBasket');
        return newBasket;
    }

    function _aggregateCosts(cs) {
        let cost = 0;
        angular.forEach(cs, function(c) {
            cost += (c.Quantity * c.UnitAmount);
        });
        return cost;
    }

    function _costByProduct(type, basketId) {
        return _productsByType(type, basketId, true)
            .then(function(p) {
                return p ? _aggregateCosts(p.CostBreakdown) : 0;
            });
    }

    //[ { CurrencyCode: String, Total: Number } ]
    function _requestedItemsCostsByProduct(type, basketId) {
        return _productsByType(type, basketId, true)
            .then(product => {
                let costs = {};
                let costList = [];
                if (product) {
                    _.each(product.RequestedItems, i => {
                        let val = costs[i.LocalCurrency] || 0;
                        costs[i.LocalCurrency] = val + (i.UnitAmount * i.Quantity);
                    });
                    _.forOwn(costs, (value, key) => {
                        costList.push({ CurrencyCode: key, Total: value });
                    });
                }
                return costList;
            });
    }

    function _optionIndex(options, id) {
        return arrayUtil.indexOf(options, function(o) {
            return o.OptionId === id;
        });
    }

    function _removeProduct(type, basketId) {
        return _productsByType(type, basketId, true)
            .then(p => {
                if (p != null) {
                    return removeProductById(p.ProductId, basketId);
                }
            });
    }

    function removeProductById(productId, basketId) {
        return $http.post(`${url}removeproduct`, {
                BasketId: basketId,
                ProductId: productId
            })
            .then(result => {
                basket = $q.when(result.data);
                costBreakdownResult = null;
                broker.publish('productRemovedFromBasket');
            });
    }

    function _addProductDetails(p, rehydrator) {
        if (p && !p.Details) {
            return rehydrator(p.ProductId).then(function(p2) {
                p.Details = p2;
                return p;
            });
        }
        return p;
    }

    function _rehydrateProducts(type, rehydrator, basketId, firstOnly) {
        return _productsByType(type, basketId)
            .then(products => {
                if (firstOnly) { // Products that don't support multiples
                    return _addProductDetails(products[0], rehydrator);
                }

                return $q.all(
                    products.reduce((promises, p) => {
                        promises.push(_addProductDetails(p, rehydrator));
                        return promises;
                    }, [])
                );
            });
    }

    function _concatCostBreakdowns(products) {
        let result = [];
        _.keys(_.omit(products, 'all')).forEach(p => {
            arrayUtil.wrapNonArray(products[p])
                .forEach(product => {
                    const cb = product && product.CostBreakdown;
                    if (cb) {
                        result = result.concat(cb);
                    }
                });
        });
        return result;
    }

    function _changeOption(type, productId, optionId, operation, basketId, quantity) {
        return $http.post(url + operation, {
            BasketId: basketId,
            ProductId: productId,
            OptionId: optionId,
            ChosenQuantity: quantity
        }).then(function(result) {
            basket = $q.when(result.data);
            costBreakdownResult = null;
            return _optionsByType(type, basketId);
        });
    }

    function _changeOptions(type, productId, options, operation, basketId) {
        return $http.post(url + operation, {
            BasketId: basketId,
            ProductId: productId,
            Options: options
        }).then(function(result) {
            basket = $q.when(result.data);
            costBreakdownResult = null;
            return _optionsByType(type, basketId);
        });
    }

    function _checkChauffeur(marhaba) {
        if (!marhaba) {
            return false;
        }

        function isChauffeur(availableOption, selectedOption) {
            if (availableOption.Type === 4 && availableOption.Id === selectedOption.OptionId) {
                return true;
            }
            return false;
        }

        const selectedOptions = marhaba.Options;
        const availableOptions = marhaba.Details.AvailableOptions;

        for (let x = availableOptions.length - 1; x >= 0; x--) {
            for (let i = selectedOptions.length - 1; i >= 0; i--) {
                if (isChauffeur(availableOptions[x], selectedOptions[i])) {
                    return true;
                }
            }
        }
        return false;
    }

    function _calculateProductTotals(products) {
        products.total = 0;
        products.totalNet = 0;
        products.totalTravelAgentCommission = 0;

        const currency = searchUnitService.getCurrency();
        angular.forEach(products, function(product) {
            product.total = 0;
            product.totalNet = 0;
            product.totalTravelAgentCommission = 0;
            product.costBreakdown = (product.costBreakdown ? product.costBreakdown : product.CostBreakdown);
            angular.forEach(product.costBreakdown, function(item) {
                product.total += (item.UnitAmount * item.Quantity);
                product.totalNet += (item.NetUnitAmount * item.Quantity);
                item.TravelAgentCommission = (item.ManualCommission ? item.ManualCommission : item.TravelAgentCommission);
                product.totalTravelAgentCommission += (item.TravelAgentCommission * item.Quantity);
                item.Margin = item.UnitAmount - item.NetUnitAmount;
            });

            product.totalStr = $filter('customCurrency')(product.total, currency);
            product.totalNetStr = $filter('customCurrency')(product.totalNet, currency);
            product.totalTravelAgentCommissionStr = $filter('customCurrency')(product.totalTravelAgentCommission, currency);
            product.totalMargin = product.total - product.totalNet;
            product.totalMarginStr = $filter('customCurrency')(product.totalMargin, currency);

            product.title = (product.group ? titles[product.group]() : productNames[product.ProductType])
                || titles[productGroup.Extra](); // Default title to 'Extras' when missing
            product.icon = productIcons[product.ProductType];
            products.total += product.total;
            products.totalNet += product.totalNet;
            products.totalTravelAgentCommission += product.totalTravelAgentCommission;
        });
        products.totalStr = $filter('customCurrency')(products.total, currency);
        products.totalNetStr = $filter('customCurrency')(products.totalNet, currency);
        products.totalTravelAgentCommissionStr = $filter('customCurrency')(products.totalTravelAgentCommission, currency);

        products.totalMargin = products.total - products.totalNet;
        products.totalMarginStr = $filter('customCurrency')(products.totalMargin, currency);
        return products;
    }

    function getCheckInDateForFlight(flightArrival) {
        const landsAfterCutOff = flightArrival.getHours() >= TRPCONFIG.Domain.DepartureFlightCutOff;
        const zeroTime = dateUtil.zeroTime(flightArrival, true);
        let cutOff = landsAfterCutOff ? zeroTime : dateUtil.addDays(zeroTime, -1, true);
        if (TRPCONFIG.Domain.ChangeHotelNightsDuration) {
            cutOff = dateUtil.addDays(zeroTime, -1, true);
        }
        return cutOff;
    }

    function getCheckOutDateForFlight(flightReturn) {
        if (TRPCONFIG.Domain.ReturnFlightCutOff < 0) {
            return dateUtil.zeroTime(flightReturn, true);
        }
        const departsBeforeCutOff = flightReturn.getHours() < TRPCONFIG.Domain.ReturnFlightCutOff;
        const zeroTime = dateUtil.zeroTime(flightReturn, true);
        return departsBeforeCutOff ? dateUtil.addDays(zeroTime, -1, true) : zeroTime;
    }

    //the problem with this is that if the user refreshes the flights list, we will hit this before the
    //hotel search request has been restored. Proglem.
    function _adjustSearchDatesIfNecessary(f, tripId) {
        return $q.all([
                tripService.getHotelsRequestCheckInDate(tripId),
                tripService.getHotelsRequestCheckOutDate(tripId)])
            .then(dates => {
                const [checkIn, checkOut] = dates.map(d => dateUtil.serialiseDate(d));
                const newHotelsRequestDates = {};
                const legs = f.Legs;
                const flightArrival = dateUtil.parseDate(legs[0].Segments[legs[0].Segments.length - 1].ArrivalDate);
                const flightReturn = legs.length > 1 ? dateUtil.parseDate(legs[legs.length - 1].Segments[0].DepartureDate) : null;
                const requiredCheckIn = getCheckInDateForFlight(flightArrival);
                const requiredCheckOut = getCheckOutDateForFlight(flightReturn);

                if (checkIn == null && checkOut == null && TRPCONFIG.Domain2.ResetAdjustingDatesFixEnabled) {
                    return newHotelsRequestDates;
                }

                if (requiredCheckIn !== checkIn) {
                    newHotelsRequestDates.CheckInDate = requiredCheckIn;
                }
                if (requiredCheckOut !== checkOut) {
                    newHotelsRequestDates.CheckOutDate = requiredCheckOut;
                }
                return newHotelsRequestDates;
            });
    }

    function addVoucher(basketId, voucherCode) {
        const req = {
            VoucherCode: voucherCode || '',
            BasketId: basketId,
        };

        return $http.post('/api2/basket/addvoucher', req)
            .then(res => {
                const data = res.data;
                const discountMsg = data.DiscountMessages && data.DiscountMessages.length > 0 && data.DiscountMessages[0] || '';
                cookieService.set('VoucherWarnMessage', JSON.stringify(discountMsg));

                return data;
            });
    }

    function addHotel(searchId, estabId, roomIds, basketId, bookingPath, packageId, rebookId, discountCode, voucherCode) {
        //reclaim price difference only for single - room hotel bookings
        const reclaimPriceDifference = TRPCONFIG.Domain.ReclaimPriceDifferenceEnabledFE && roomIds.length === 1;
        let request = {
            AvailabilitySearchId: searchId,
            EstabId: estabId,
            RoomAndBoardIds: roomIds,
            DiscountCode: discountCode || TRPCONFIG.DiscountCode || '',
            VoucherCode: voucherCode || '',
            BookingPath: bookingPath,
            BasketId: basketId,
            ReclaimPriceDifference: reclaimPriceDifference
        };

        if (TRPCONFIG.Domain2.SkywardsTierPromoEnabled) {
            const SkywardsLoginUser = JSON.parse(sessionStorage.getItem('skywardsLoginUser'));
            const Tier = (SkywardsLoginUser && SkywardsLoginUser.data && SkywardsLoginUser.data.Contact) ?
            SkywardsLoginUser.data.Contact.Tier : null;
            request.LoyaltyInfo = {
                SkywardsTier: Tier
            };
        }

        return hotelService.getHotelDetails(request)
        .then(d => {
            sessionStorage.setItem('preselectedHotelData', JSON.stringify({
                Accommodation: productType.Accommodation,
                searchId,
                DetailsId: d.DetailsId,
                basketId,
                options: undefined,
                packageId,
                rebookId,
                d
            }));
            return _addProduct(productType.Accommodation, searchId, d.DetailsId, basketId, undefined, packageId, rebookId);
        })
        .then(() => service.hotel(basketId));
    }

    function addingFlight() {
        return addingFlightResult != null;
    }

    function buildBaggageArray(opExtras, bagOpts, type, baggageOptions) {
        //for best fit flight selection this will come through as null
        if (bagOpts == null) {
            return;
        }

        switch (type) {
            case 'multi':
                for (let i = 0; i < bagOpts.bags; i++) {
                    if (opExtras[i].Options.length > 1) {
                        let option = null;
                        //this is just needed for our initial release so we can go out without being coupled to flights
                        //once they have their data updated we should pick the default bag rather that just the 1st one
                        // in the list (only applies to multi options
                        if (TRPCONFIG.BaggageUseDefaultOption === true) {
                            const defaultOption = _.find(opExtras[i].Options, { IsDefault: true });
                            option = {
                                OptionId: defaultOption.OptionId,
                                ChosenQuantity: defaultOption.Quantity
                            };
                        } else {
                            option = {
                                OptionId: opExtras[i].Options[1].OptionId,
                                ChosenQuantity: opExtras[i].Options[1].Quantity
                            };
                        }
                        baggageOptions.push(option);
                    }
                }
                break;
            case 'single':
                for (let j = 0; j < bagOpts.bags; j++) {
                    if (opExtras[j] != null) {
                        baggageOptions.push({
                            OptionId: opExtras[j].OptionId,
                            ChosenQuantity: opExtras[j].Quantity
                        });
                    }
                }
                break;
        }
    }

    function getCheckInOptions(sector) {
        return arrayUtil.first(sector.OptionalExtras, function(o) {
            return o.Type === 4;
        });
    }

    function getSpecificCheckInOption(options, typeName) {
        return arrayUtil.first(options.MultiOptionalExtras[0].Options, function(o) {
            return o.Type === typeName;
        });
    }


    function addCheckInOptionsIfNecessary(sector, opts, baggageOptions) {
        //if the flight has CheckInOptions we need to add default online checkin options as well
        const checkInOptions = getCheckInOptions(sector);
        if (checkInOptions && opts) {
            const nobags = getSpecificCheckInOption(checkInOptions, 'OnlineCheckinNoBaggage');
            const withbags = getSpecificCheckInOption(checkInOptions, 'OnlineCheckinWithBaggage');
            if (opts.bags > 0 && withbags != null) {
                baggageOptions.push({
                    OptionId: withbags.OptionId,
                    ChosenQuantity: opts.bags
                });
            }
            if (opts.bags < opts.maxbags) {
                baggageOptions.push({
                    OptionId: nobags.OptionId,
                    ChosenQuantity: opts.maxbags - opts.bags
                });
            }
        }
    }

    function updateBrandedFare(params) {
        const {
            searchId,
            basketId,
            packageId,
            details
        } = params;
            const baggageOptions = [];
            _.forEach(details.FlightSectorOptionalExtras, function(sector) {
                addBaggageOptions(sector, params, baggageOptions);
            });
            return _addProduct(productType.Flight, searchId, details.DetailsId, basketId, baggageOptions, packageId, undefined, true)
                .then(() => {
                    return service.flight(basketId);
                });
    }

    function addFlight(searchId, flight, basketId, tripId, verifyDates, opts, packageId) {
        let checkDates = !flight.HasFullDates;
        let adjustingDates = $q.when();
        if (verifyDates && flight.HasFullDates && flight.Legs.length > 1) {
            adjustingDates = _adjustSearchDatesIfNecessary(flight, tripId).then(newHotelsRequestDates => {
                if (!_.isEmpty(newHotelsRequestDates)) {
                    checkDates = false;
                    hotelSearch.adjustHotelCheckInCheckOutDates(tripId, newHotelsRequestDates);
                }
            });
        }

        addingFlightResult = adjustingDates.then(function() {
            return flightDetail.getFlightDetails(tripId, {
                AvailabilitySearchId: searchId,
                FlightId: flight.FlightId,
                IncludeSeatPlan: TRPCONFIG.DeviceSettings.SeatPlanEnabled,
                IncludeBrandedFares: TRPCONFIG.Domain.EnableFlightDetailsWithBrandedFare
            }).then(function(d) {
                if (d != null) {
                    sessionStorage.setItem('FlightDetailsId', d.DetailsId);
                    const baggageOptions = [];
                    _.forEach(d.FlightSectorOptionalExtras, function(sector) {
                        addBaggageOptions(sector, opts, baggageOptions);
                    });

                    return _addProduct(productType.Flight, searchId, d.DetailsId, basketId, baggageOptions, packageId)
                        .then(function(res) {
                            const preselectedHotelData = sessionStorage.getItem('preselectedHotelData');
                            return preselectedHotelData !== null ? _addProduct(...Object.values(JSON.parse(preselectedHotelData))) : res;
                        })
                        .then(function() {
                            addingFlightResult = null;
                            return service.flight(basketId).then(function(f) {
                                if (TRPCONFIG.Domain.EnableFlightDetailsWithBrandedFare) {
                                    let selectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight') || '{}');
                                    if (selectedFlight && selectedFlight.Legs.length) {
                                        selectedFlight.Legs = f.Details.Itinerary.Legs;
                                        sessionStorage.setItem('storeSelectedFlight', JSON.stringify(selectedFlight));
                                    }
                                }
                                //in the case where the flight did not have full dates we need to defer checking that the hotel search
                                //dates match until we have the full info i.e. after the details call
                                if (verifyDates && checkDates && flight.Legs.length > 1) {
                                    return _adjustSearchDatesIfNecessary(f.Details.Itinerary, tripId).then(newHotelsRequestDates => {
                                        if (!_.isEmpty(newHotelsRequestDates)) {
                                            broker.publish('searchDatesAdjusted', {
                                                tripId,
                                                dates: newHotelsRequestDates
                                            });
                                        }
                                        return f;
                                    });
                                }
                                return f;
                            });
                        });
                }
                return null;
            });
        });
        return addingFlightResult;
    }


    function addMultiDestHolidayFlight(searchId, flight, basketId, tripId, verifyDates, opts, packageId) {
        // Duplicate of addFlight() with no getFlightDetails() because it already ran immediately prior
        let checkDates = !flight.HasFullDates;
        let adjustingDates = $q.when();
        if (verifyDates && flight.HasFullDates && flight.Legs.length > 1) {
            adjustingDates = _adjustSearchDatesIfNecessary(flight, tripId).then(newHotelsRequestDates => {
                if (!_.isEmpty(newHotelsRequestDates)) {
                    checkDates = false;
                    broker.publish('searchDatesAdjusted', { tripId, dates: newHotelsRequestDates });
                }
            });
        }
        addingFlightResult = adjustingDates.then(function() {
            const baggageOptions = [];
            _.forEach(flight.FlightSectorOptionalExtras, function(sector) {
                addBaggageOptions(sector, opts, baggageOptions);
            });

            return _addProduct(productType.Flight, searchId, flight.DetailsId, basketId, baggageOptions, packageId)
                .then(function() {
                    addingFlightResult = null;
                    return service.flight(basketId).then(function(f) {
                        if (verifyDates && checkDates && flight.Legs.length > 1) {
                            return _adjustSearchDatesIfNecessary(f.Details.Itinerary, tripId).then(newHotelsRequestDates => {
                                if (!_.isEmpty(newHotelsRequestDates)) {
                                    broker.publish('searchDatesAdjusted', { tripId, dates: newHotelsRequestDates });
                                }
                                return f;
                            });
                        }
                        return f;
                    });
                });
        });
        return addingFlightResult;
    }

    function addMultiFlight(searchId, option, basketId, tripId) {
        return flightDetail.getFlightDetails(tripId, {
            AvailabilitySearchId: searchId,
            FlightId: option.FlightId,
            IncludeSeatPlan: false,
            MultiSector: true
        }).then(function(d) {
            if (!d) {
                return null;
            }
            return _addProduct(productType.Flight, searchId, d.DetailsId, basketId);
        });
    }

    function addBaggageOptions(sector, opts, baggageOptions) {
        const optionalExtras = arrayUtil.first(sector.OptionalExtras, o => o.Type === 0);
        if (optionalExtras != null) {
            if (optionalExtras.MultiOptionalExtras.length > 0) {
                buildBaggageArray(optionalExtras.MultiOptionalExtras, opts, 'multi', baggageOptions);
            } else {
                buildBaggageArray(optionalExtras.SingleOptionalExtras, opts, 'single', baggageOptions);
            }

            addCheckInOptionsIfNecessary(sector, opts, baggageOptions);
        }
    }

    function addTransfer(type, searchId, transferId, basketId) {
        if (type === productType.Transfer) {
            return transferDetail.getTransferDetails({
                AvailabilitySearchId: searchId,
                TransferId: transferId
            }).then(function(d) {
                return _addProduct(productType.Transfer, searchId, d.DetailsId, basketId)
                    .then(function() {
                        return service.transfer(basketId);
                    });
            });
        }

        if (type === productType.Accommodation) {
            let preselectedHotelData = JSON.parse(sessionStorage.getItem('preselectedHotelData'));
            return _addProduct(productType.Accommodation, preselectedHotelData.searchId,
                preselectedHotelData.DetailsId, basketId, transferId)
            .then(function() {
                return service.hotel(basketId);
            });
        }
    }

    function addMarhaba(searchId, productId, basketId, options) {
        return marhabaService.getProductDetails(searchId, productId)
            .then(function(details) {
                return _addProduct(productType.Marhaba, searchId, details.DetailsSearchId, basketId, options)
                    .then(function() {
                        return service.marhaba(basketId, productId);
                    });
            });
    }

    function removeMarhaba(basketId) {
        return _removeProduct(productType.Marhaba, basketId);
    }

    function addMarhabaOption(productId, optionId, quantity, basketId) {
        return _productsByType(productType.Marhaba, basketId, true)
            .then(function(p) {
                if (p && p.Options) {
                    const i = _optionIndex(p.Options, optionId);
                    if (i < 0) {
                        p.Options.push({ OptionId: optionId });
                    }
                }
                return _changeOption(productType.Marhaba, productId, optionId, 'addoption', basketId, quantity);
            });
    }

    function marhaba(basketId, productId) {
        return _productsByType(productType.Marhaba, basketId, true).then(function(p) {
            if (p && !p.Details) {
                return marhabaService.rehydrate(productId, p.AvailabilitySearchId)
                    .then(function(res) {
                        p.Details = res;
                        return p;
                    });
            }
            return p;
        });
    }

    function marhabaHolidayPath(basketId) {
        return _getBasket(basketId)
            .then(function(b) {
                return b.Products.length > 1;
            });
    }

    function hotel(basketId) {
        return _rehydrateProducts(productType.Accommodation, hotelService.rehydrate.bind(hotelService), basketId,
            true); // `firstOnly` when not dynamic packaging
    }

    function flight(basketId) {
        if (addingFlightResult) {
            return addingFlightResult
                .then(function(f) {
                    return f;
                });
        }
        return _rehydrateProducts(productType.Flight, flightDetail.rehydrate.bind(flightDetail), basketId,
            true); // `firstOnly` when not dynamic packaging
    }

    function transfer(basketId) {
        return _rehydrateProducts(productType.Transfer, transferDetail.rehydrate.bind(transferDetail), basketId,
            true); // `firstOnly` when not dynamic packaging
    }

    function carHire(basketId) {
        return _rehydrateProducts(productType.CarHire, carHireDetailsService.rehydrate.bind(carHireDetailsService), basketId, true);
    }

    function optionConditions(basketId) {
        return service.flight(basketId).then(function(f) {
            if (f) {
                return f.Details.OptionConditions;
            }
            return {};
        });
    }

    function flightOptions(basketId) {
        if (addingFlightResult != null) {
            return addingFlightResult.then(function() {
                return _optionsByType(productType.Flight, basketId);
            });
        }
        return _optionsByType(productType.Flight, basketId);
    }

    function carHireOptions(basketId) {
        return _optionsByType(productType.CarHire, basketId).then(function(options) {
            return arrayUtil.map(options, function(o) {
                return o.OptionId;
            });
        });
    }

    function _flushBasket() {
        basket = null;
        attractionsBasket = null;
    }

    function _refreshBasket(basketId) {
        return $q.when(basketId || getBasketId())
            .then(bId => {
                _flushBasket();
                return _getBasket(bId);
            })
            .then(() => broker.publish('basketRefreshed'));
    }

    function destroyBasket() {
        _flushBasket();
        TRPCONFIG.BasketId = null;
    }

    function clearBasket(basketId) {
        destroyBasket();
        return $http.post(`${url}clearbasket`, JSON.stringify(basketId))
            .then(res => {
                broker.publish('basketCleared');
                return res;
            });
    }

    function setPaymentMethod(cardTypeId, basketId) {
        TRPCONFIG.Domain.CardTypeId = cardTypeId;
        return _getBasket(basketId)
            .then(function(b) {
                if (b.CardTypeId !== cardTypeId) {
                    return $http.post(`${url}setpaymentmethod`, {
                        BasketId: basketId,
                        CardTypeId: cardTypeId
                    }).then(function(result) {
                        result.data.CardTypeId = cardTypeId;
                        basket = $q.when(result.data);
                        return {
                            CardHandlingFee: result.data.CardHandlingFee,
                            AirlineSurcharge: result.data.AirlineSurcharge
                        };
                    });
                }
                return {
                    CardHandlingFee: b.CardHandlingFee,
                    AirlineSurcharge: b.AirlineSurcharge
                };
            });
    }

    function createBasket(forHoliday) {
        const domain = TRPCONFIG.Domain;
        const reqParams = {
            AccountingCurrencyCode: domain.AccountingCurrencyCode,
            CurrencyCode: searchUnitService.getCurrency(),
            DomainId: domain.DomainId,
            ForHoliday: forHoliday,
            CultureCode: domain.CultureCode
        };

        basket = $http.post(`${url}create`, reqParams)
            .then(result => {
                TRPCONFIG.BasketId = result.data.BasketId;
                broker.publish('attractionsBasketUpdated');
                broker.publish('basketCreated');
                return result.data;
            });
        return basket;
    }

    function removeAccomodation(basketId) {
        return _removeProduct(productType.Accommodation, basketId);
    }

    function removeFlight(basketId) {
        return _removeProduct(productType.Flight, basketId);
    }

    function removeTransfer(basketId) {
        return _removeProduct(productType.Transfer, basketId);
    }

    function all(basketId, productId) {
        const p = [
            service.flight(basketId),
            service.hotel(basketId),
            service.transfer(basketId),
            service.insurance(basketId),
            service.carHire(basketId),
            service.parking(basketId),
            service.attraction(basketId)
        ];

        if (TRPCONFIG.Domain.MarhabaEnabled) {
            p.push(service.marhaba(basketId, productId));
        }

        return $q.all(p)
            .then(function(results) {
                _storeAdaptiveBookingFlags(results);
                return {
                    f: results[0],
                    h: results[1],
                    t: results[2],
                    i: results[3],
                    c: results[4],
                    p: results[5],
                    a: results[6],
                    m: TRPCONFIG.Domain.MarhabaEnabled ? results[7] : null,
                    all: results
                };
            });
    }

    function _storeAdaptiveBookingFlags(results) {
        const marhaba = 5;
        const bookingFlags = results.reduce((acc, current, i) => {
            if ((!Array.isArray(current) && (current !== undefined)) ||
                (Array.isArray(current) && (current.length > 0)) ||
                (!Array.isArray(current) && (current !== undefined) && (i === marhaba) && TRPCONFIG.Domain.MarhabaEnabled)) {
                acc.push(bookingExtraOptionsMap[i]);
            }
            return acc;
        }, []);
        sessionStorage.setItem('adaptiveBookingFlags', JSON.stringify(bookingFlags));
    }

    function _rehydrateDynamicPackage() {
    // Rehydrate `Details` data on `basket.Products` entries
        return getBasketId().then(bId => {
            let services = [
                service.flight(bId),
                service.hotel(bId),
                service.transfer(bId),
                service.adHoc(bId)
            ];

            if (TRPCONFIG.Domain.MarhabaEnabled) {
                services.push(service.marhaba(bId));
            }

            return $q.all(services);
        });
    }

    function getDynamicPackage(flatList) {
    // Rehydrates and returns `basket.Products` grouped by type (or `flatList`)
        return _rehydrateDynamicPackage()
            .then(res => {
                // Normalise entries to [{}, {}, ...]
                res = res.map(p => arrayUtil.wrapNonArray(p));
                return flatList ? _.flatten(res) : {
                    f: res[0],
                    h: res[1],
                    t: res[2],
                    ah: res[3],
                    m: TRPCONFIG.Domain.MarhabaEnabled ? res[4] : null
                };
            });
    }

    function removeOption(type, productId, optionId, basketId) {
        return _productsByType(type, basketId, true)
            .then(function(p) {
                if (p && p.Options) {
                    const i = _optionIndex(p.Options, optionId);
                    if (i >= 0) {
                        p.Options.splice(i, 1);
                    }
                }
                return _changeOption(type, productId, optionId, 'removeoption', basketId);
            });
    }

    function addOption(type, productId, optionId, basketId, quantity) {
        return _productsByType(type, basketId, true)
            .then(function(p) {
                if (p && p.Options) {
                    const i = _optionIndex(p.Options, optionId);
                    if (i < 0) {
                        p.Options.push({
                            OptionId: optionId,
                            ChosenQuantity: quantity
                        });
                    }
                }
                return _changeOption(type, productId, optionId, 'addoption', basketId, quantity);
            });
    }

    function addOptions(type, productId, options, basketId) {
        return options.length === 0 ?
            _optionsByType(type, basketId) :
            _changeOptions(type, productId, options, 'addoptions', basketId);
    }

    function removeOptions(type, productId, options, basketId) {
        return options.length === 0 ?
            _optionsByType(type, basketId) :
            _changeOptions(type, productId, options, 'removeoptions', basketId);
    }

    function getNotes(basketId) {
        return _getBasket(basketId).then(b => b.Notes);
    }

    function addNote(basketId, text) {
        const payload = JSON.stringify({
            BasketId: basketId,
            NoteText: text
        });
        const conf = {
            ignoreErrors: true
        };

        return $http.post(`${url}addnote`, payload, conf)
            .then(res => {
                basket = $q.when(res.data);
                return res.data;
            })
            .catch(() => ({}));
    }

    function _hidePricesIfNecessary(products) {
        return tripService.usePackageRates().then(packagePrice => {
            if (packagePrice) {
                //check whether flight cost breakdown needs to be shown
                let productsToHidePrice = TRPCONFIG.Domain.PackageFlightPrice ? [products.h, products.f] : products.h;
                angular.forEach([productsToHidePrice], product => {
                    arrayUtil.wrapNonArray(product).forEach(p => {
                        if (p) {
                            angular.forEach(p.CostBreakdown, function(el) {
                                el.HidePrice = true;
                            });
                        }
                    });
                });
            }
            return products;
        });
    }

    function groupProducts(products, excluded = {}) {
        const results = [];
        _.forEach(productResultMap, (groupName, k) => {
            if (!excluded[k]) {
                arrayUtil.wrapNonArray(products[k]).forEach(p => {
                    if (p && p.CostBreakdown) {
                        const groupEntry = _.find(results, {
                            group: productGroup[groupName]
                        });
                        if (groupEntry) {
                            groupEntry.costBreakdown = (groupEntry.costBreakdown || []).concat(p.CostBreakdown);
                            groupEntry.futurePaymentAdminFees = (groupEntry.futurePaymentAdminFees || []).concat(p.FuturePaymentAdminFees);
                        } else {
                            results.push({
                                costBreakdown: p.CostBreakdown,
                                futurePaymentAdminFees: p.FuturePaymentAdminFees,
                                group: productGroup[groupName]
                            });
                        }
                    }
                });
            }
        });
        return results;
    }

    function costBreakdownGrouped(basketId) {
        return service.all(basketId)
            .then(products => {
                let extras = {};
                let exclusions;

                // Extras
                return _hidePricesIfNecessary(products).then(es => {
                    if (products.h || products.f) {
                        extras = _enhanceCostBreakdownsWithProductTypes(angular.copy(es));
                        delete extras.h;
                        delete extras.f;
                        exclusions = { t: true, p: true, a: true };
                    }
                }).then(() => {
                    const results = groupProducts(_enhanceCostBreakdownsWithProductTypes(products), exclusions);

                    if (!_.isEmpty(extras)) {
                        results.push({
                            costBreakdown: _concatCostBreakdowns(extras),
                            group: productGroup.Extra
                        });
                    }
                    return tripService.usePackageRates().then(packagePrice => {
                        results.isPackage = packagePrice;
                        return _calculateProductTotals(results);
                    });
                });
            });
    }

    function _enhanceCostBreakdownsWithProductTypes(products) {
        _.forEach(products, value => {
            if (value && value.ProductType) {
                const x = value.ProductType;
                _.forEach(value.CostBreakdown, value => {
                    value.ProductType = x;
                });
            }
        });
        return products;
    }

    function costBreakdown(basketId, productId) {
        if (costBreakdownResult) {
            return costBreakdownResult;
        }
        costBreakdownResult = service.all(basketId, productId)
            .then(_getAllCostBreakdowns);

        return costBreakdownResult;
    }

    function payments(basketId) {
        return _getBasket(basketId)
            .then(function(b) {
                return _enrichPayments(b);
            });
    }

    function payDirectTotal(basketId) {
        return service.payments(basketId).then(payment => {
            let directAmount = 0;
            _.forEach(payment.products, p => {
                directAmount = _.reduce(p.directPayments, (result, value) => {
                    return result + value.amount;
                }, directAmount);
            });
            return directAmount;
        });
    }

    function balancesDue(basketId, productId) {
        const s = (b1, b2) => b1.Due > b2.Due ? 1 : -1;

        return service.all(basketId, productId)
            .then(function(products) {
                const balances = {};
                if (products.all) {
                    products.all.forEach(product => {
                        arrayUtil.wrapNonArray(product).forEach(p => {
                            if (p && p.FuturePayments && p.FuturePayments.length > 0) {
                                p.FuturePayments.forEach(fp => {
                                    if (balances[fp.Due] == null) {
                                        balances[fp.Due] = {
                                            Due: fp.Due,
                                            Amount: 0
                                        };
                                    }
                                    balances[fp.Due].Amount += fp.Amount;
                                });
                            }
                        });
                    });
                }
                const balancesArray = Object.keys(balances).map(d => balances[d]);
                balancesArray.sort(s);
                return balancesArray;
            });
    }

    function totalDeposit(basketId) {
        return payDepositAggregates(basketId)
            .then(pda => pda.TotalImmediatePayment);
    }

    function payDepositAggregates(basketId) {
        return _getBasket(basketId)
            .then(b => b.PayDepositAggregates);
    }

    function totalDiscount(basketId) {
        return service.costBreakdown(basketId)
            .then(sumDiscounts);
    }

    function sumDiscounts(cb) {
        return cb.reduce((sum, c) =>
            /* select only discounts. id 20 is discounts */
            c.UnitAmount < 0 && c.TypeId === 20
                ? sum + (c.Quantity * c.UnitAmount) :
                sum, 0);
    }

    function totalCost(basketId) {
        return TRPCONFIG.Domain.EnableAmendBookingV2
            ? totalAmount(basketId)
            : service.costBreakdown(basketId).then(sumCosts);
    }

    function totalAmount(basketId) {
        return service.all(basketId)
            .then(({ all }) => _(all).map(a => a ? a.TotalAmount : 0).sum());
    }

    function _getAllCostBreakdowns(products) {
        return _hidePricesIfNecessary(products).then(_concatCostBreakdowns);
    }

    function sumCosts(cb) {
        return cb.reduce((sum, c) => sum + (c.Quantity * c.UnitAmount), 0).toFixed(2);
    }

    function totalCostFromBasket(products) {
        return $q.when(products).then(_getAllCostBreakdowns).then(sumCosts);
    }

    function attractionCost(basketId) {
        return _costByProduct(productType.Attractions, basketId);
    }

    function carHireCost(basketId) {
        return _costByProduct(productType.CarHire, basketId);
    }

    function carHireRequestedItemsCosts(basketId) {
        return _requestedItemsCostsByProduct(productType.CarHire, basketId);
    }

    function marhabaCost(basketId) {
        return _costByProduct(productType.Marhaba, basketId);
    }

    function _productSpecificFields(type, basketId) {
        return _productsByType(type, basketId, true)
            .then(function(p) {
                return (p && p.ProductSpecificFields) || null;
            });
    }

    function flightSpecificInfo(basketId) {
        return _productSpecificFields(productType.Flight, basketId);
    }

    function flightCost(basketId) {
        return _costByProduct(productType.Flight, basketId);
    }

    function flightBaggageCostings(basketId) {
        return flightSpecificInfo(basketId)
            .then(i => {
                let costings = {
                    total: 0,
                    discount: 0
                };

                const baggageCosts = i.BaggageCostings;
                if (baggageCosts) {
                    costings.total = baggageCosts.Total;
                    costings.discount = baggageCosts.Discount;
                } else {
                    costings.total = i.TotalBaggageCost;
                    //this is to be removed, here so that we don't have to tie the flights release
                    // to the website release HJ-64 HJ-57
                }
                return costings;
            });
    }

    function hotelCost(basketId) {
        return _costByProduct(productType.Accommodation, basketId);
    }

    function hotelDeposit(basketId) {
        return service.hotel(basketId)
            .then(hotel => (hotel && hotel.ImmediatePayment) ? hotel.ImmediatePayment.Amount : 0);
    }

    function insuranceCost(basketId) {
        return _costByProduct(productType.Insurance, basketId);
    }

    function isAtolProtected(basketId) {
        return _getBasket(basketId)
            .then(basket => basket.IsAtolProtected);
    }


    function parkingCost(basketId) {
        return _costByProduct(productType.Parking, basketId);
    }

    function transferCost(basketId) {
        return _costByProduct(productType.Transfer, basketId);
    }

    function rules(basketId, productId) {
        return service.all(basketId, productId)
            .then(function(products) {
                const hotelOnly = products.h != null && products.f == null && products.t == null && products.m == null && products.i == null && !arrayUtil.count(products.a);
                const hasTransfer = products.t != null;
                const hasOutboundTransfer = products.t != null && products.t.Details.Itinerary.OutboundLeg != null;
                const hasInboundTransfer = products.t != null && products.t.Details.Itinerary.InboundLeg != null;
                const hasParking = products.p != null;
                const hasCarHire = products.c != null;
                const hasCarHirePayableLocally = products.c && products.c.RequestedItems && products.c.RequestedItems.length;
                const hasInsurance = products.i != null;
                const productList = [products.f, products.h, products.i, products.t, products.m, products.p, ...products.a];
                const isOriginOpenJaw = products.f && products.f.Details && products.f.Details.Itinerary && products.f.Details.Itinerary.IsOriginOpenJaw;
                const hasConnectingFlight = products.m != null && products.m.Details.MarhabaQuote.Type === 2;
                const isAttractionsStandalone = !products.h && !products.f && products.a && !!products.a.length;

                return {
                    captureMainDriver: hasCarHire,
                    hasChauffeur: _checkChauffeur(products.m),
                    hasAttraction: products.a != null,
                    hotelOnly,
                    hasMarhaba: products.m != null,
                    captureConnectingFlight: hasConnectingFlight,
                    captureFlight: (products.f == null && hasTransfer),
                    hasTransfer,
                    hasOutboundTransfer,
                    hasInboundTransfer,
                    captureOutboundFlight: hasOutboundTransfer,
                    captureInboundFlight: hasInboundTransfer,
                    captureSpecialRequests: (products.h != null || products.m != null),
                    captureHotel: (products.h == null && products.t != null),
                    captureInsurance: hasInsurance,
                    captureVehicle: hasParking,
                    showPayableNow: arrayUtil.count(productList, function(p) { return p && p.ImmediatePayment && p.ImmediatePayment.Amount > 0; }) > 0,
                    showPayableLocally: hasCarHirePayableLocally,
                    depositAllowed: arrayUtil.count(productList, function(p) { return p && p.FuturePayments && p.FuturePayments.length > 0; }) > 0,
                    showDirectPayments: arrayUtil.count(productList, function(p) { return p && p.DirectPayments && p.DirectPayments.length > 0; }) > 0,
                    showOptionalExtras: products.f != null && _.some(products.f.Details.FlightSectorOptionalExtras, sector => sector.OptionalExtras.length > 0),
                    empty: products.f === null && products.h === null && products.i == null && products.t === null,
                    showParkingQuotes: _.get(products, 'f.Details.Itinerary.Legs.length') > 1 && !isOriginOpenJaw,
                    isAttractionsStandalone
                };
            });
    }

    function insurance(basketId) {
        return _rehydrateProducts(productType.Insurance, insuranceService.rehydrate.bind(insuranceService), basketId, true);
        //return _productsByType(productType.Insurance, basketId, true);
    }

    function parking(basketId) {
        return _rehydrateProducts(productType.Parking, parkingDetailsService.rehydrate.bind(parkingDetailsService), basketId, true);
        //return _productsByType(productType.Parking, basketId, true);
    }

    function attraction(basketId) {
        return _rehydrateProducts(productType.Attractions, attractionDetailsService.rehydrate.bind(attractionDetailsService), basketId);
    }

    function adHoc(basketId) {
        return _rehydrateProducts(productType.AdHoc, adHocService.rehydrate.bind(adHocService), basketId);
    }

    function removeInsurance(basketId) {
        return _removeProduct(productType.Insurance, basketId);
    }

    function removeParking(basketId) {
        return _removeProduct(productType.Parking, basketId);
    }

    function removeAttraction(basketId) {
        return _removeProduct(productType.Attractions, basketId);
    }

    function addInsurance(searchId, quote, basketId) {
        return insuranceService.getInsuranceDetails({
            AvailabilityId: searchId,
            SchemeId: quote.QuoteType.SchemeId,
            TripTypeId: quote.QuoteType.TypeId,
            SupplierId: quote.SupplierId,
            DestinationId: quote.QuoteType.DestinationId,
            RelationshipId: quote.QuoteType.RelationshipId
        }).then(function(d) {
            const opt = [{ OptionId: `${quote.QuoteType.SchemeId}|${quote.QuoteType.TypeId}|${quote.SupplierId}|${quote.QuoteType.RelationshipId}` }];
            return _addProduct(productType.Insurance, searchId, d.DetailSearchId, basketId, opt).then(function() {
                return service.insurance(basketId);
            });
        });
    }

    function addCancellationProtection(productId, quote, basketId, quantity) {

        return addOption(productType.Accommodation, productId, quote.QuoteId, basketId, quantity)
            .then(() => {
                broker.publish('basketUpdated');
            });
    }

    function removeCancellationProtection(productId, quote, basketId) {

        return removeOption(productType.Accommodation, productId, quote.QuoteId, basketId)
            .then(() => {
                broker.publish('basketUpdated');
            });
    }

    function rehydrateBasketForPUP(basketId) {
        _flushBasket();
        basket = _getBasketById(basketId);
        return basket;
    }

    function addCar(searchId, quote, basketId) {
        return carHireDetailsService.getCarDetails({
            AvailabilitySearchId: searchId,
            CarHireQuote: quote
        }).then(function(d) {
            return _addProduct(productType.CarHire, searchId, d.DetailsSearchId, basketId)
                .then(function() {
                    return service.carHire(basketId);
                });
        });
    }

    function addParking(searchId, parking, basketId) {
        return parkingDetailsService.getParkingDetails({
            AvailabilitySearchId: searchId,
            AirportParkingQuoteId: parking
        }).then(function(d) {
            return _addProduct(productType.Parking, searchId, d.DetailsSearchId, basketId).then(function() {
                return service.parking(basketId);
            });
        });
    }

    function putAttractionExtras(searchId, attractions, basketId) {
        // Create or replace attraction extras entry in basket
        const atts = [];
        angular.forEach(attractions.selected, function(a) {
            atts.push({
                AttractionId: a,
                TicketTypesCount: attractions.occupancy[a]
            });
        });
        return removeAttraction(basketId)
            .then(() =>
                attractionDetailsService.getAttractionDetails({
                    AvailabilitySearchId: searchId,
                    AttractionRequests: atts
                }))
            .then(details => _addProduct(
                    productType.Attractions,
                    searchId,
                    details.DetailsSearchId,
                    basketId
                ))
            .then(() => service.attraction(basketId));
    }

    function addAttraction(productId, productTags, basketId) {
        // Add standalone attractions product to basket
        const domain = TRPCONFIG.Domain;
        return $http.post(
            '/api2/attractions/bookingfunnel/addtobasket', {
                BasketId: basketId,
                AvailabilityRequest: {
                    Id: productId,
                    DomainId: domain.DomainId,
                    Tags: productTags,
                    Currency: domain.CurrencyCode
                }
            },
            { ignoreErrors: true }
        ).then(
            res => _refreshAttractionsBasket(res.data, basketId),
            err => ({ error: err })
        );
    }

    function updateAttraction(lineItemId, updates, basketId) {
    // Modify standalone attractions product in basket
        return $http.post(
            '/api2/attractions/bookingfunnel/updatebasket', {
                BasketId: basketId,
                LineItemId: lineItemId,
                Updates: updates,
                DomainId: TRPCONFIG.Domain.DomainId
            },
            { ignoreErrors: true }
        ).then(
            res => _refreshAttractionsBasket(res.data, basketId),
            err => ({ error: err })
        );
    }

    function removeAttractionsLineItem(lineItemId, basketId) {
    // Remove standalone attractions product from basket
        return $http.post(
            '/api2/attractions/bookingfunnel/removefrombasket', {
                BasketId: basketId,
                LineItemId: lineItemId
            },
            { ignoreErrors: true }
        ).then(
            res => _refreshAttractionsBasket(res.data, basketId),
            err => ({ error: err })
        );
    }

    function getAttractionsBasket() {
    // Get all standalone attractions products in basket
        return attractionsBasket || (
            attractionsBasket = getAttractionsBasketId()
                .then(id => $http.post(`/api2/attractions/bookingfunnel/getbasket?basketId=${id}`))
                .then(res => res.data)
            );
    }

    function getAttractionsBasketId() {
        return $q.when(
                TRPCONFIG.BasketId ||
                service.createBasket()
                    .then(b => TRPCONFIG.BasketId = b.BasketId)
            );
    }

    function _refreshAttractionsBasket(basketData, basketId) {
        // `attractions/bookingfunnel/...` API makes back-end changes to the basket
        const responseBasketId = basketData.Basket.BasketId;
        basket = null;
        attractionsBasket = null;
        attractionDetailsService.purge();

        // Back-end creates a new basket if existing contains non-attractions products
        if (responseBasketId !== basketId) {
            TRPCONFIG.BasketId = responseBasketId;
        }

        return _getBasket(responseBasketId)
            .then(() => service.attraction(responseBasketId)) // Rehydrate `basket` products
            .then(() => {
                // Can't use `basketService.updateBasket()` due to circular dependency error
                broker.publish('basketUpdated');
                // Publish/return 'attractions/bookingfunnel' data format
                broker.publish('attractionsBasketUpdated', basketData);
                return basketData;
            });
    }

    function removeCar(basketId) {
        return _removeProduct(productType.CarHire, basketId);
    }

    function getBasketId(tripId) {
        if (tripId) {
            return tripService.getTrip(tripId).then(trip => {
                if (trip) {
                    return trip.BasketId;
                }
                return $q.when();
            });
        } else if (TRPCONFIG.BasketId) {
            return $q.when(TRPCONFIG.BasketId);
        }

        return createBasket().then(basket => {
            TRPCONFIG.BasketId = basket.BasketId;
            return basket.BasketId;
        });
    }

    function getProductCount() {
        return getBasketId()
        .then(basketId => _getBasket(basketId))
        .then(basket => _.filter(basket.Products, p => p.CostBreakdown.length > 0).length);
    }

    function _simplifiedBaggageOptions(basketId) {
        return flight(basketId).then(f => {
            const baggageOptionsSimplified = [];

            const addToArray = function(arr, index, bagOption, price, weight) {
                if (arr.length <= index) {
                    arr.push({ TotalPrice: 0, Bags: [], UnitWeightKg: [] });
                }
                arr[index].Bags.push(bagOption);
                arr[index].TotalPrice += price;
                arr[index].UnitWeightKg.push(weight);
            };
            //for multiple sectors adding 1 bag will mean multiple options being added under the hood
            //so 1 bag option may contain an array of options
            // e.g if you add a bag to your out leg your are more than likely going to need it on the way back
            _.forEach(f.Details.FlightSectorOptionalExtras, extras => {
                const baggageOptions = _.find(extras.NonCheckInOptions, ['Type', 0]);
                if (baggageOptions) {
                    _.forEach(baggageOptions.MultiOptionalExtras, (multi, index) => {
                        const opt = _.find(multi.Options, { IsDefault: true });
                        addToArray(baggageOptionsSimplified, index, opt.Key, opt.UnitAmount, opt.UnitWeightKg);
                    });

                    const options = _.filter(baggageOptions.SingleOptionalExtras, { IsDefault: true });
                        _.forEach(options, (opt, index) => {
                            addToArray(baggageOptionsSimplified, index, opt.Key, opt.UnitAmount, opt.UnitWeightKg);
                    });
                }
            });
            return baggageOptionsSimplified;
        });
    }

    function _baggageOptionComparer(o1, o2) {
        const o1qty = o1.Quantity || o1.ChoosenQuantity;
        const o2qty = o2.Quantity || o2.ChoosenQuantity;
        return o1.OptionId === o2.OptionId && o1qty === o2qty;
    }

    function simplifiedBaggageCount(basketId) {
        //figure out how many bags from our possible list
        //are actually selected
        return $q.all([
            flightOptions(basketId),
            _simplifiedBaggageOptions(basketId)
        ]).then(results => {
            let bagsSelected = 0;
            const basketOptions = results[0];
            const bagOptions = results[1];

            //check the whole option is in our basket
            _.forEach(bagOptions, option => {
                const selected = _.every(option.Bags, function(opt) {
                    return _.some(basketOptions, function(bo) {
                        return _baggageOptionComparer(opt, bo);
                    });
                });
                if (selected) {
                    bagsSelected++;
                }
            });

            const minWeight = (bagOptions.length > 0) ? _.min(_.flatMap(bagOptions, o => o.UnitWeightKg)) : 0;

            return {
                selected: bagsSelected,
                maxAllowed: bagOptions.length,
                price: (bagOptions.length > 0) ? bagOptions[0].TotalPrice : 0,
                unitWeightKg: minWeight
            };
        });
    }

    function updateBaggageOptions(basketId, count, model) {
        return $q.all([
            flight(basketId),
            flightOptions(basketId),
            _simplifiedBaggageOptions(basketId)
        ]).then(results => {
            const flight = results[0];
            const bagOptions = results[2];
            const allBagOptions = flight.Details.FlightSectorOptionalExtras.reduce((res, cur) => {
                const baggageNonCheckInOptions = _.find(cur.NonCheckInOptions, ['Type', 0]);
                return res.concat(baggageNonCheckInOptions.MultiOptionalExtras.reduce((res, cur) =>
                    res.concat(cur.Options.map(op => op.Key)),
                    []).concat(baggageNonCheckInOptions.SingleOptionalExtras.map(option => option.Key)));
                },
                []);
            const basketOptions = _.intersectionBy(results[1], allBagOptions, 'OptionId');
            let selectedOptions = [];

            const createBasketOption = option => {
                return {
                    OptionId: option.OptionId,
                    ChosenQuantity: option.Quantity
                };
            };

            //use the count to figure out which bags we need to select
            _.times(count, i => {
                selectedOptions = selectedOptions.concat(bagOptions[i].Bags);
            });

            //compare what we want with what we have and add/remove accordingly
            const optionsToRemove = _.map(
                                        arrayUtil.difference(basketOptions, selectedOptions, _baggageOptionComparer),
                                        o => createBasketOption(o)
                                    );
            const optionsToAdd = _.map(
                                    arrayUtil.difference(selectedOptions, basketOptions, _baggageOptionComparer),
                                    o => createBasketOption(o)
                                );

            return removeOptions(productType.Flight, flight.ProductId, optionsToRemove, basketId)
                .then(() => addOptions(productType.Flight, flight.ProductId, optionsToAdd, basketId))
                .then(options => {
                     _.pullAllBy(model[0], optionsToRemove, 'OptionId');

                    //not great, a bit of a band aid while we still use the 'old' options page and have all flight
                    //options handled together (seats, meals) using the code in optionsCtrl
                    const optionsOldFormat = _.map(optionsToAdd, o => {
                        return {
                            OptionId: o.OptionId,
                            Quantity: o.ChosenQuantity
                        };
                    });
                    model[0].push(...optionsOldFormat);
                    return options;
                });
        });
    }

    function updatePriorityBoarding(basketId, pbDetails, pbSelectedStatus) {
        return flight(basketId).then(flight => {
            const pbBasketOptions = [{
                OptionId: pbDetails.OptionId,
                ChosenQuantity: pbDetails.Quantity
            }];

            return pbSelectedStatus
                ? addOptions(productType.Flight, flight.ProductId, pbBasketOptions, basketId)
                : removeOptions(productType.Flight, flight.ProductId, pbBasketOptions, basketId);
        });
    }

    function setProductVisibility(userRequest) {
        return $http.post(`${url}setproductvisibility`, userRequest);
    }

    function setAdjustmentVisibility(adjustmentRequest) {
        return $http.post(`${url}setadjustmentvisibility`, adjustmentRequest);
    }

    function checkBasketBookingAllowed(basketId) {
        return _getBasket(basketId)
            .then(basket => {
                return basket.Products.every(p =>
                    (p.ProductSpecificFields == null) || (p.ProductSpecificFields.IsBookable == null) || (p.ProductSpecificFields.IsBookable));
        });
    }

    function setBasketIdentity(basketId, userRequest) {
        let validateTravelAgent = req => !_.isEmpty(req)
            && !_.isEmpty(req.TravelAgent)
            && !_.isEmpty(_.trim(req.TravelAgent.FirstName))
            && !_.isEmpty(_.trim(req.TravelAgent.LastName));

        return !validateTravelAgent(userRequest)
            ? $q.reject('bad request')
            : $http.post(`${url}setidentities`, {
                BasketId: basketId,
                TravelAgent: userRequest ? userRequest.TravelAgent : null,
                TravelAgentCustomer: userRequest ? userRequest.TravelAgentCustomer : {}
            }).then(result => {
                basket = $q.when(result.data);
                return getBasketIdentity(result.data.BasketId);
            });
    }

    function getBasketIdentity(basketId) {
        return _getBasket(basketId)
            .then(basket => {
                return {
                    TravelAgent: basket.TravelAgent,
                    TravelAgentCustomer: basket.TravelAgentCustomer
                };
        });
    }

    function getBasketCurrency(basketId) {
        return _getBasket(basketId).then(basket => basket && basket.Currency || '');
    }

    function applyCancelations(basketId, legacyBasketId) {
        if (!$routeParams.BookingRef) {
            return $q.when();
        }
        return $http.post(`${url}applycancellations`, {
                CultureCode: TRPCONFIG.Domain.CultureCode,
                BasketId: basketId,
                DomainId: TRPCONFIG.Domain.DomainId,
                LegacyBasketId: legacyBasketId,
            })
            .then(({ data }) => {
                basket = $q.when(data);
            });
    }

    function extrasBreakdown(arr) {
        let extras = {
            transfersCost: 0,
            insuranceCost: 0,
            parkingCost: 0,
            carHireCost: 0,
            marhabaCost: 0
        };

        _.each(arr, cb => {
            if (cb.ProductType === productType.Transfer) {
                extras.transfersCost += cb.Quantity * cb.UnitAmount;
            }
            if (cb.ProductType === productType.Insurance) {
                extras.insuranceCost += cb.Quantity * cb.UnitAmount;
            }
            if (cb.ProductType === productType.Parking) {
                extras.parkingCost += cb.Quantity * cb.UnitAmount;
            }
            if (cb.ProductType === productType.CarHire) {
                extras.carHireCost += cb.Quantity * cb.UnitAmount;
            }
            if (cb.ProductType === productType.Marhaba) {
                extras.marhabaCost += cb.Quantity * cb.UnitAmount;
            }
        });

        return extras;
    }

    /*
      Subscriptions
    */
    broker.subscribe('basketStore', 'travelAgentSignIn', () => _refreshBasket());

    broker.subscribe('basketStore', 'agentSignedInToBooking', ({ data }) =>
        setBasketIdentity(TRPCONFIG.BasketId, {
            TravelAgent: data.TravelAgent,
            TravelAgentCustomer: _.omit(data.Contact, ['Email', 'BookingId', 'SiteId'])
        }));

    return service;
}
})();
